import { useLocation } from 'react-router-dom';

import useUrlListParams from '../../../hooks/useUrlListParams';
import { ManagedLeadCategory } from '../../../services/api/managed-leads/managedLeads';

export interface ManagedLeadFilters {
  stages: string[];
  needsUpdate: boolean;
}

/**
 * URL state of a managed lead list: the page and search every list has, plus
 * the two filters only In gestione offers. Reading them from the query string
 * is what makes a view reloadable, shareable and returnable to from a detail.
 */
const useManagedLeadListParams = (category: ManagedLeadCategory) => {
  const params = useUrlListParams();
  const location = useLocation();
  const inProgress = category === 'in_progress';
  const filters: ManagedLeadFilters = {
    stages: inProgress ? params.readSet('stages') : [],
    needsUpdate:
      inProgress && params.searchParams.get('needsUpdate') === 'true',
  };

  return {
    ...params,
    filters,
    returnTo: `${location.pathname}${location.search}`,
    applyFilters: ({ stages, needsUpdate }: ManagedLeadFilters) =>
      params.updateFilter((nextParams) => {
        if (stages.length) nextParams.set('stages', stages.join(','));
        else nextParams.delete('stages');
        if (needsUpdate) nextParams.set('needsUpdate', 'true');
        else nextParams.delete('needsUpdate');
      }),
  };
};

export default useManagedLeadListParams;
